import React from "react";
import { useTranslation } from "react-i18next";

const ProjectsSidebar = ({
  activeSection,
  setActiveSection,
  directions,
  investorCategories,
  selectedDirectionId,
  setSelectedDirectionId,
  selectedCategoryId,
  setSelectedCategoryId,
  directionCounts,
  categoryCounts,
  totalProjectsCount,
  totalInvestorCount,
}) => {
  const { t } = useTranslation();

  const handleSectionClick = (section) => {
    setActiveSection(section);
    if (section === "projects") setSelectedDirectionId(null);
    if (section === "investor") {
      if (investorCategories.length > 0) {
        setSelectedCategoryId(investorCategories[0].id);
      }
    }
  };

  return (
    <div className="structure-sidebar bg-gradient p-3 rounded-3 shadow-lg">
      <div className="sidebar-nav">
        <div className="mb-2">
          <button
            onClick={() => handleSectionClick("projects")}
            className={`alt_sidebar-department-button btn w-100 text-start d-flex align-items-center justify-content-between p-3 rounded-2 border-0 fw-semibold ${
              activeSection === "projects" ? "active" : ""
            }`}
          >
            <span className="d-flex align-items-center">
              <i className="bi bi-folder-fill me-2"></i>
              {t("Projects")}
            </span>
            <i
              className={`bi ${
                activeSection === "projects"
                  ? "bi-chevron-down"
                  : "bi-chevron-right"
              }`}
            ></i>
          </button>

          {activeSection === "projects" && (
            <div className="sidebar-submenu mt-2 ps-3">
              <div className="border-start border-2 border-white border-opacity-25 ps-3">
                <button
                  onClick={() => setSelectedDirectionId(null)}
                  className={`alt_sidebar-sub-button btn btn-sm w-100 text-start p-2 rounded-2 border-0 d-flex align-items-center justify-content-between ${
                    selectedDirectionId === null ? "active" : ""
                  }`}
                >
                  <span>{t("All")}</span>
                  {totalProjectsCount > 0 && (
                    <span className="badge bg-secondary rounded-pill small">
                      {totalProjectsCount}
                    </span>
                  )}
                </button>

                {directions.map((direction) => (
                  <button
                    key={direction.id}
                    onClick={() => setSelectedDirectionId(direction.id)}
                    className={`alt_sidebar-sub-button btn btn-sm w-100 text-start p-2 rounded-2 border-0 d-flex align-items-center justify-content-between ${
                      selectedDirectionId === direction.id ? "active" : ""
                    }`}
                  >
                    <span className="text-truncate me-2">{direction.name}</span>
                    {directionCounts[direction.id] !== undefined && (
                      <span className="badge bg-secondary rounded-pill small">
                        {directionCounts[direction.id]}
                      </span>
                    )}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="mb-2">
          <button
            onClick={() => handleSectionClick("investor")}
            className={`alt_sidebar-department-button btn w-100 text-start d-flex align-items-center justify-content-between p-3 rounded-2 border-0 fw-semibold ${
              activeSection === "investor" ? "active" : ""
            }`}
          >
            <span className="d-flex align-items-center">
              <i className="bi bi-graph-up-arrow me-2"></i>
              {t("InvestGuide")}
            </span>
            <i
              className={`bi ${
                activeSection === "investor"
                  ? "bi-chevron-down"
                  : "bi-chevron-right"
              }`}
            ></i>
          </button>

          {activeSection === "investor" && (
            <div className="sidebar-submenu mt-2 ps-3">
              <div className="border-start border-2 border-white border-opacity-25 ps-3">
                {/* <button
                  onClick={() => setSelectedCategoryId(null)}
                  className={`alt_sidebar-sub-button btn btn-sm w-100 text-start p-2 rounded-2 border-0 d-flex align-items-center justify-content-between ${
                    selectedCategoryId === null ? "active" : ""
                  }`}
                >
                  <span>{t("All")}</span>
                  {totalInvestorCount > 0 && (
                    <span className="badge bg-secondary rounded-pill small">
                      {totalInvestorCount}
                    </span>
                  )}
                </button> */}

                {investorCategories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => setSelectedCategoryId(category.id)}
                    className={`alt_sidebar-sub-button btn btn-sm w-100 text-start p-2 rounded-2 border-0 d-flex align-items-center justify-content-between ${
                      selectedCategoryId === category.id ? "active" : ""
                    }`}
                  >
                    <span className="text-truncate me-2">{category.name}</span>
                    {categoryCounts[category.id] !== undefined && (
                      <span className="badge bg-secondary rounded-pill small">
                        {categoryCounts[category.id]}
                      </span>
                    )}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectsSidebar;
